module.exports = __webpack_public_path__ + "img/a13.8e4a1536.png";